import {
  getFirestore,
  doc,
  updateDoc,
  addDoc,
  deleteDoc,
  collection,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

const editMembershipPlan = async (user, data, branchId, planId) => {
  const db = getFirestore();
  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser || currentUser.uid !== user.uid) {
    throw new Error("Unauthorized user");
  }

  const planDocRef = doc(db, "membershipPlans", planId);

  try {
    await updateDoc(planDocRef, {
      ...data,
      branchId, // Ensure branchId is included
    });
    return { success: true };
  } catch (error) {
    console.error("Error updating membership plan:", error);
    throw error;
  }
};

const createMembershipPlan = async (user, data) => {
  const db = getFirestore();
  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser || currentUser.uid !== user.uid) {
    throw new Error("Unauthorized user");
  }

  const plansCollection = collection(db, "membershipPlans");

  try {
    const docRef = await addDoc(plansCollection, {
      ...data,
      branchId: data.branchId,
    });
    return { id: docRef.id, ...data };
  } catch (error) {
    console.error("Error creating membership plan:", error);
    throw error;
  }
};

const deleteMembershipPlan = async (user, branchId, planId) => {
  const db = getFirestore();
  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser || currentUser.uid !== user.uid) {
    throw new Error("Unauthorized user");
  }

  const planDocRef = doc(db, "membershipPlans", planId);

  try {
    await deleteDoc(planDocRef);
    return { success: true };
  } catch (error) {
    console.error("Error deleting membership plan:", error);
    throw error;
  }
};

export { editMembershipPlan, createMembershipPlan, deleteMembershipPlan };
